import Vue from 'vue'
import CookieConsentPlugin from './cookieConsent'
import MetaPixelPlugin from './metaPixel'

export function setupTracking() {
  Vue.config.productionTip = false
  Vue.use(CookieConsentPlugin)
  Vue.use(MetaPixelPlugin)
  Vue.prototype.$metaPixel.init('821034234136815')
}